// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsABC_container__VRlJh {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ReportsABC_header__IupkH {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ReportsABC_header__IupkH h2 {
  font-size: 22px;
  font-weight: 600;
  color: #222;
}

.ReportsABC_header__IupkH p {
  font-size: 14px;
  color: #777;
}

/* Фильтры */
.ReportsABC_filters__\\+Mo2E {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));
  gap: 16px;
}

.ReportsABC_select__suR2I {
  min-width: 200px;
}

.ReportsABC_dateInput__aCPBZ {
  background: white;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
}

/* Таблица */
.ReportsABC_tableWrapper__naGsL {
  overflow-x: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.ReportsABC_table__9C-6W {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.ReportsABC_table__9C-6W thead {
  background-color: #f8f9fa;
}

.ReportsABC_table__9C-6W th {
  text-align: left;
  font-weight: 600;
  padding: 12px 16px;
  font-size: 13px;
  color: #444;
  border-bottom: 1px solid #ddd;
}

.ReportsABC_table__9C-6W td {
  padding: 12px 16px;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  color: #333;
}

.ReportsABC_table__9C-6W tbody tr:hover {
  background-color: #f5f5f5;
  transition: 0.2s ease;
}

/* Цвета */
.ReportsABC_table__9C-6W td:nth-child(10),
.ReportsABC_table__9C-6W td:nth-child(11),
.ReportsABC_table__9C-6W td:nth-child(12),
.ReportsABC_table__9C-6W td:nth-child(13) {
  color: #2e7d32; /* зелёный для прибыли */
}

.ReportsABC_table__9C-6W td:nth-child(14) {
  font-weight: 600;
}


`, "",{"version":3,"sources":["webpack://./src/pages/ReportsPages/ReportsABC.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,UAAU;AACV;;;;EAIE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header h2 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #222;\n}\n\n.header p {\n  font-size: 14px;\n  color: #777;\n}\n\n/* Фильтры */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));\n  gap: 16px;\n}\n\n.select {\n  min-width: 200px;\n}\n\n.dateInput {\n  background: white;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #333;\n}\n\n/* Таблица */\n.tableWrapper {\n  overflow-x: auto;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.table thead {\n  background-color: #f8f9fa;\n}\n\n.table th {\n  text-align: left;\n  font-weight: 600;\n  padding: 12px 16px;\n  font-size: 13px;\n  color: #444;\n  border-bottom: 1px solid #ddd;\n}\n\n.table td {\n  padding: 12px 16px;\n  font-size: 13px;\n  border-bottom: 1px solid #eee;\n  color: #333;\n}\n\n.table tbody tr:hover {\n  background-color: #f5f5f5;\n  transition: 0.2s ease;\n}\n\n/* Цвета */\n.table td:nth-child(10),\n.table td:nth-child(11),\n.table td:nth-child(12),\n.table td:nth-child(13) {\n  color: #2e7d32; /* зелёный для прибыли */\n}\n\n.table td:nth-child(14) {\n  font-weight: 600;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReportsABC_container__VRlJh`,
	"header": `ReportsABC_header__IupkH`,
	"filters": `ReportsABC_filters__+Mo2E`,
	"select": `ReportsABC_select__suR2I`,
	"dateInput": `ReportsABC_dateInput__aCPBZ`,
	"tableWrapper": `ReportsABC_tableWrapper__naGsL`,
	"table": `ReportsABC_table__9C-6W`
};
export default ___CSS_LOADER_EXPORT___;
